import { RouteRecordRaw } from 'vue-router';
import { GenerateRecordPage } from '@/pages/record-fill';

export const routeName = 'EditarRegistro';

export const route: RouteRecordRaw = {
  path: 'registros-da-qualidade/:prefix/editar-registro/:recordId',
  name: routeName,
  component: GenerateRecordPage,
  meta: {
    requiresAuth: true,
    permissions: [{ action: 'update', subject: 'Record' }],
  },
};
